import { db } from '@/db/db';
import { newId } from '@/workouts/model';
import type { PlannedRide, PlanStatus } from './model';

export function localDate(d = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function parseLocalDate(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y!, (m ?? 1) - 1, d ?? 1);
}

export function addDays(s: string, n: number): string {
  const d = parseLocalDate(s);
  d.setDate(d.getDate() + n);
  return localDate(d);
}

/** Monday of the week containing `s`. */
export function weekStart(s: string): string {
  const d = parseLocalDate(s);
  const dow = (d.getDay() + 6) % 7; // Mon=0
  d.setDate(d.getDate() - dow);
  return localDate(d);
}

export async function planWorkout(date: string, workoutId: string): Promise<PlannedRide> {
  const p: PlannedRide = { id: newId('plan'), date, workoutId, status: 'planned', updatedAt: Date.now() };
  await db.plans.put(p);
  return p;
}

export async function listPlans(from: string, to: string): Promise<PlannedRide[]> {
  const rows = await db.plans.where('date').between(from, to, true, true).toArray();
  return rows.filter((p) => !p.deleted);
}

export async function plansForDay(date: string): Promise<PlannedRide[]> {
  return listPlans(date, date);
}

export async function setPlanStatus(id: string, status: PlanStatus, rideId?: string): Promise<void> {
  const p = await db.plans.get(id);
  if (!p) return;
  const next: PlannedRide = { ...p, status, updatedAt: Date.now() };
  if (rideId) next.rideId = rideId;
  else if (status !== 'done') delete next.rideId;
  await db.plans.put(next);
}

export async function movePlan(id: string, date: string): Promise<void> {
  const p = await db.plans.get(id);
  if (p) await db.plans.put({ ...p, date, updatedAt: Date.now() });
}

export async function removePlan(id: string): Promise<void> {
  const p = await db.plans.get(id);
  if (p) await db.plans.put({ ...p, deleted: true, updatedAt: Date.now() });
}
